/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, SearchTextField, BoxSpinnerView, BoxEmptyView } from '@components/atoms'
import { List } from '@components/molecules'
import { UserListItem } from '@components/molecules/user/UserListItem'

import { UserType } from '@schemas'
import { SecetionUserListType, ApiGetDataStatus } from '@redux/index'

interface PropsType {
	status: ApiGetDataStatus
	userList: UserType[]
	userSectionList?: SecetionUserListType[]
	onUserClick?: (aUser: UserType) => void
	openedUserCateg?: string[]
	onCollapsOpen?: (id: string) => void
	selectedUserIds?: string[]
	showSearch?: boolean
	searchLabel?: string
	showDepartmentName?: boolean
	userInfoStyle?: React.CSSProperties
	userInfoClassName?: string
	userInfoLeftAccessory?: (aUser: UserType) => JSX.Element
}

export const UserList = (props: PropsType) => {
	const { status, userList } = props

	// state
	const [searchKeyword, setSearchKeyword] = React.useState<string>('')
	const [searchedUserList, setSearchedUserList] = React.useState<UserType[]>([])

	// variables
	const userSectionList = props.userSectionList ?? []
	const showSearch = props.showSearch ?? true
	const showDepartmentName = props.showDepartmentName ?? false

	React.useLayoutEffect(() => {
		const newSearchedUsers: UserType[] =
			searchKeyword !== ''
				? userList.filter(
						(aUser: UserType) =>
							aUser.id.toLowerCase().match(searchKeyword.toLowerCase()) ||
							aUser.name.match(searchKeyword) ||
							aUser.email.match(searchKeyword),
				  )
				: []
		setSearchedUserList(newSearchedUsers)
	}, [searchKeyword, userList])

	const onSearchChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const str = e.target.value

		setSearchKeyword(str)
	}, [])

	return (
		<View css={style}>
			{showSearch && (
				<View>
					<SearchTextField
						onChange={onSearchChange}
						label={props.searchLabel ?? '검색'}
					/>
				</View>
			)}

			{status === 'init' || status === 'loading' ? (
				<BoxSpinnerView />
			) : status === 'empty' ? (
				<BoxEmptyView isGrey={true} title="사원이 없습니다." />
			) : status === 'ok' ? (
				<View>
					{searchKeyword !== '' ? (
						// search result
						<List>
							{searchedUserList.map(aSearchedUser => {
								const isChecked: boolean | undefined = props.selectedUserIds
									? props.selectedUserIds.includes(aSearchedUser.id)
									: undefined

								return (
									<UserListItem
										key={aSearchedUser.id}
										user={aSearchedUser}
										isChecked={isChecked}
										onUserClick={props.onUserClick}
										showDepartmentName={showDepartmentName}
										userInfoStyle={props.userInfoStyle}
										userInfoClassName={props.userInfoClassName}
										userInfoLeftAccessory={props.userInfoLeftAccessory}
									/>
								)
							})}
						</List>
					) : null}

					<List
						css={[
							{ margin: 0, padding: 0 },
							searchKeyword !== '' ? { opacity: 0 } : null,
						]}
					>
						{userSectionList.length > 0
							? userSectionList.map(aDepartment => {
									// const isOpen: boolean | undefined =
									// 	props.openedUserCateg !== undefined
									// 		? props.openedUserCateg.includes(aDepartment.code)
									// 		: undefined

									return (
										<></>
										// <CollapsibleListItem
										// 	key={aDepartment.code}
										// 	id={aDepartment.code}
										// 	title={aDepartment.name}
										// 	isOpen={isOpen}
										// 	onIsOpen={props.onCollapsOpen}
										// 	style={{
										// 		height: '2rem',
										// 		background: grey[100],
										// 		borderBottom: '1px solid white',
										// 		borderRadius: '5px',
										// 	}}
										// >
										// 	{aDepartment.users.map(aUser => {
										// 		const isChecked: boolean | undefined = props.selectedUserIds
										// 			? props.selectedUserIds.includes(aUser.id)
										// 			: undefined

										// 		return (
										// 			<UserListItem
										// 				key={aUser.id}
										// 				user={aUser}
										// 				isChecked={isChecked}
										// 				onUserClick={props.onUserClick}
										// 				showDepartmentName={showDepartmentName}
										// 				userInfoStyle={props.userInfoStyle}
										// 				userInfoClassName={props.userInfoClassName}
										// 				userInfoLeftAccessory={props.userInfoLeftAccessory}
										// 			/>
										// 		)
										// 	})}
										// </CollapsibleListItem>
									)
							  })
							: userList.map(aUser => {
									const isChecked: boolean | undefined = props.selectedUserIds
										? props.selectedUserIds.includes(aUser.id)
										: undefined

									return (
										<UserListItem
											key={aUser.id}
											user={aUser}
											isChecked={isChecked}
											onUserClick={props.onUserClick}
											showDepartmentName={showDepartmentName}
											userInfoStyle={props.userInfoStyle}
											userInfoClassName={props.userInfoClassName}
											userInfoLeftAccessory={props.userInfoLeftAccessory}
										/>
									)
							  })}
					</List>
				</View>
			) : (
				<></>
			)}
		</View>
	)
}

const style = css({
	width: '100%',
	height: '100%',
})
